"use client";

import useSWR from "swr";
import { useParams } from "react-router-dom";

import SWR_KEYS from "@/constants/swr-keys";
import IUser from "@/interfaces/user.interface";
import { User, userService } from "@/services/user.service";
import { RequestsBaseReturn } from "@/types/requests.types";

export type UseGetUserByIdReturn = RequestsBaseReturn<IUser | null>;

const mapToIUser = (u: User): IUser => ({
  id: u.id,
  userKey: u.userKey,
  accessCount: u.accessCount,
  lastAccess: new Date(u.lastAccess),
  rowDate: new Date(u.rowdate ?? u.lastAccess),
  permissions: (u.permissions as unknown as IUser["permissions"]) || [],
  status: u.status as unknown as IUser["status"],
  email: u.email,
  languageCode: u.languageCode as unknown as IUser["languageCode"],
  name: u.name,
  phone1: u.phone1,
  phone2: u.phone2,
  userProfile: u.userProfile as unknown as IUser["userProfile"],
  enableSoundNotification: u.enableSoundNotification,
});

const useGetUserById = (): UseGetUserByIdReturn => {
  const params = useParams<{ userId?: string }>();
  const requestedId = params.userId ? Number(params.userId) : undefined;
  const {
    data: raw = null,
    isValidating: isLoading,
    error,
  } = useSWR<User, Error, string | null>(
    SWR_KEYS.getUserById,
    () => userService.getById(requestedId),
    {
      revalidateOnFocus: false,
    }
  );

  const data = raw ? mapToIUser(raw) : null;
  return { data, isLoading, error };
};

export default useGetUserById;
